import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntl } from '../../util/reactIntl';
import { formatAddressShort, getAddressLabel } from '../../util/dataExtractors';

import css from './AddressSelector.module.css';

const AddressSelector = props => {
  const {
    className,
    addresses,
    selectedAddressId,
    onSelect,
    onAddNew,
    disabled,
    placeholder,
    ariaLabel,
  } = props;

  const intl = useIntl();
  const classes = classNames(css.root, className);

  const handleChange = e => {
    const value = e.target.value;
    if (value === 'add_new') {
      onAddNew?.();
    } else if (value) {
      const selectedAddress = addresses.find(addr => addr.id === value);
      if (selectedAddress) {
        onSelect(selectedAddress);
      }
    }
  };

  return (
    <div className={classes}>
      <select
        className={css.select}
        aria-label={ariaLabel || intl.formatMessage({ id: 'AddressSelector.label' })}
        value={selectedAddressId || ''}
        onChange={handleChange}
        disabled={disabled}
      >
        <option value="" disabled>
          {placeholder || intl.formatMessage({ id: 'AddressSelector.placeholder' })}
        </option>
        {addresses.map((address, index) => {
          const label = getAddressLabel(address, index, intl);
          const shortAddress = formatAddressShort(address);
          return (
            <option key={address.id} value={address.id}>
              {label}: {shortAddress}
            </option>
          );
        })}
        {onAddNew && (
          <option value="add_new">
            + {intl.formatMessage({ id: 'AddressSelector.addNew' })}
          </option>
        )}
      </select>
    </div>
  );
};

AddressSelector.defaultProps = {
  className: null,
  addresses: [],
  selectedAddressId: null,
  disabled: false,
  placeholder: null,
  onAddNew: null,
  ariaLabel: null,
};

AddressSelector.propTypes = {
  className: PropTypes.string,
  addresses: PropTypes.array,
  selectedAddressId: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onAddNew: PropTypes.func,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  // Names the list for screen readers when the page shows no label for it
  ariaLabel: PropTypes.string,
};

export default AddressSelector;
